import { RG_TYPE } from "@project-rouge/rg-core";
import { getSortedChildrenPerMuscle } from "./index16.js";
import { splitArrayBy } from "./index80.js";
function getApartmentArray(building, level) {
  const apartmentArray = [];
  const childrenPerMuscle = getSortedChildrenPerMuscle(building, level);
  for (const section of childrenPerMuscle) {
    const apartmentSections = splitArrayBy(section.children, (child) => child.type !== RG_TYPE.Apartment);
    if (apartmentSections.length > 0) {
      apartmentArray.push(...apartmentSections);
    }
  }
  return apartmentArray;
}
export {
  getApartmentArray
};
//# sourceMappingURL=index152.js.map
